import {Selector} from '@ngxs/store';
import {PlaylistsState} from '@store/playlists/playlists.state';
import {PlaylistsStateModel} from '@store/playlists/playlists-state.model';
import {IPlaylist} from '@interfaces/playlist';
import {ViewType} from '@shared/enums/view-type.enum';

export class PlaylistsSelectors {
  @Selector([PlaylistsState])
  static getPlaylists(state: PlaylistsStateModel): IPlaylist[] {
    return state.playlists;
  }

  @Selector([PlaylistsState])
  static getPlaylistsInUse(state: PlaylistsStateModel): number {
    return state.playlistsInUse;
  }

  @Selector([PlaylistsState])
  static getSelectedPlaylist(state: PlaylistsStateModel): IPlaylist | null {
    return state.selectedPlaylist;
  }

  @Selector([PlaylistsState])
  static getCurrentPage(state: PlaylistsStateModel): number {
    return state.currentPage;
  }

  @Selector([PlaylistsState])
  static getPlaylistPerPage(state: PlaylistsStateModel): number {
    return state.playlistPerPage;
  }

  @Selector([PlaylistsState])
  static getSearchParam(state: PlaylistsStateModel): string {
    return state.searchParam;
  }

  @Selector([PlaylistsState])
  static getPlaylistsViewType(state: PlaylistsStateModel): ViewType {
    return state.viewType;
  }
}
